import { useEffect, useState } from "react";
import {
  get_document_categories,
  get_pv_list,
  upload_document,
} from "../../utils/endpoints";

import Select from "react-select";
import makeAnimated from "react-select/animated";

export default function UploadDocument({
  selected_file,
  selected_rcr,
  setSelectedFile,
  loadAttachmentList,
  context,
}) {
  const [categories, setCategories] = useState();
  const [pv, setPv] = useState();
  const [pv_selected, setPvSelected] = useState();

  useEffect(() => {
    if (context.session) {
      (async () => {
        const response = await context.httpRequest(
          "get",
          get_document_categories,
          null,
          context.session.token
        );
        if (response.result) setCategories(response.data);

        if (selected_rcr) {
          const response_pv = await context.httpRequest(
            "get",
            get_pv_list.replace("*", selected_rcr),
            null,
            context.session.token
          );
          if (response_pv.result) setPv(response_pv.data);
        }
      })();
    }
  }, [context]);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (selected_file) {
      let obj = {
        idCategory: parseInt(e.target.category.value),
        pvIds: pv_selected.map((item) => {
          return item.value;
        }),
        isShared: e.target.is_shared.checked,
        fileName: selected_file[0].name,
        sizeInMb: selected_file[0].size,
        attachmentType: selected_file[0].type.includes("image") ? 0 : 1,
      };

      let response = await context.httpRequest(
        "post",
        upload_document,
        obj,
        context.session.token
      );

      if (response.result) uploadFile(response.data);
    }
  };

  const uploadFile = async (options) => {
    let response = await context.httpRequest(
      options.httpOperation,
      options.presignedUrl,
      selected_file[0],
      null
    );

    if (response.ok) {
      context.openMessage(
        "success",
        "Il documento è stato caricato correttamente"
      );
      setSelectedFile();
      loadAttachmentList();
      document.querySelector("#close-modal-button").click();
    } else
      context.openMessage(
        "danger",
        "Si è verificato un problema durante l'upload"
      );
  };

  const handleClose = () => {
    setSelectedFile();
    document.querySelector("#close-modal-button").click();
  };

  return (
    <form onSubmit={(e) => handleUpload(e)} className="w-100 mx-auto">
      <small className="d-block mt-3">Punti vendita</small>
      <Select
        className="mb-3 w-100"
        maxMenuHeight={140}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: "1px solid #cccccc",
            borderRadius: 10,
            padding: "0.4rem 0.8rem",
            outline: "none",
            marginTop: 5,
            minWidth: 300,
          }),
        }}
        required={true}
        closeMenuOnSelect={false}
        components={makeAnimated()}
        isMulti
        onChange={(items) => setPvSelected(items)}
        options={
          pv
            ? pv.map((item) => {
                return {
                  value: item.pv.id,
                  label: `[${item.pv.codicePv}] ${item.pv.indirizzo}`,
                };
              })
            : []
        }
      />
      <small className="d-block mt-3">Categoria</small>
      <select className="w-100" name="category" required>
        <option value="">Seleziona..</option>
        {categories
          ? categories.map((item, index) => {
              return (
                <option value={item.id} key={index}>
                  {item.name}
                </option>
              );
            })
          : null}
      </select>
      <div className="d-flex align-items-center mt-3">
        <input name="is_shared" id="sharable" type="checkbox" />
        <label htmlFor="sharable" className="ms-2">
          è un documento condiviso?
        </label>
      </div>
      <div className="text-end mt-5">
        <button
          type="button"
          className="q8-blue-button py-2 px-3 ms-auto me-3"
          onClick={() => handleClose()}
        >
          ANNULLA
        </button>
        <button type="submit" className="q8-blue-button py-2 px-3">
          SALVA
        </button>
      </div>
    </form>
  );
}
